module.exports = __webpack_public_path__ + "static/media/CartCard.9d807c52.svg";